import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Login from './components/Login';
import Register from './components/Register';
import ResetPassword from './components/ResetPassword';
import ConfirmResetPassword from './components/ConfirmResetPassword';
import Dashboard from './components/Dashboard';
import AnalysisForm from './components/AnalysisForm';
import DraftReviewPage from './components/DraftReviewPage';
import Cases from './components/Cases';
import CaseDetails from './components/CaseDetails';
import DocumentLibrary from './components/DocumentLibrary';
import GetPlan from './components/GetPlan';
import FlyConanLinkAccount from './components/FlyConanLinkAccount';
import ProtectedRoute from './components/ProtectedRoute';
import EngineerQueryBar from './components/EngineerQueryBar';
import { ReviewDraftProvider } from './contexts/ReviewDraftContext';
import './components/SharedStyles.css';
import './App.css';

function AppContent() {
  const { isAuthenticated } = useAuth();
  const location = useLocation();
  const showQueryBar = isAuthenticated && location.pathname === '/analysis/review';

  return (
    <ReviewDraftProvider>
      <div className={`App${showQueryBar ? ' app-with-query-bar' : ''}`}>
        <Routes>
            {/* Public Routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/reset-password/confirm" element={<ConfirmResetPassword />} />
            
            {/* Protected Routes */}
            <Route 
              path="/auth/link-flyconan" 
              element={
                <ProtectedRoute>
                  <FlyConanLinkAccount />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/" 
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/analysis" 
              element={
                <ProtectedRoute>
                  <AnalysisForm />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/get-plan" 
              element={
                <ProtectedRoute>
                  <GetPlan />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/analysis/review" 
              element={
                <ProtectedRoute>
                  <DraftReviewPage />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/cases" 
              element={
                <ProtectedRoute>
                  <Cases />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/cases/:caseNumber" 
              element={
                <ProtectedRoute>
                  <CaseDetails />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/documents" 
              element={
                <ProtectedRoute>
                  <DocumentLibrary />
                </ProtectedRoute>
              } 
            />
            
            {/* Redirect any unknown routes to dashboard */}
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        {showQueryBar && <EngineerQueryBar />}
      </div>
    </ReviewDraftProvider>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppContent />
      </Router>
    </AuthProvider>
  );
}

export default App;
